import React, { memo } from 'react';
import { Footer } from '../components/Footer';
const subProcessors = [{
  vendor: 'Vercel, Inc.',
  function: 'Application hosting & edge compute (frontend + API routes)',
  data: 'All Nisa request traffic; coach/teacher account metadata; transient request bodies (chat messages, file URLs); deployment logs.',
  region: 'US',
  safeguards: 'SOC 2 Type II, ISO 27001, GDPR, HIPAA-eligible'
}, {
  vendor: 'Neon, Inc.',
  function: 'Managed PostgreSQL (application DB + AI memory DB)',
  data: 'All persisted application data: users, organizations, teachers, touchpoints, coaching goals, action steps, file metadata; AI agent memory threads and embeddings; classroom recording metadata, transcripts, and Video Coaching findings.',
  region: 'US (us-east-2)',
  safeguards: 'SOC 2 Type II, GDPR, encryption at rest and in transit'
}, {
  vendor: 'Amazon Web Services, Inc. (AWS)',
  function: 'Object storage (S3) and signed delivery (CloudFront) for uploads and classroom recordings; key management (KMS) for integration credentials; underlying compute for Vercel and Neon.',
  data: 'Coach- and teacher-uploaded files: lesson recordings, audio, documents, images; classroom recordings (video and audio) and processed renditions. Presigned URLs are HTTPS-only.',
  region: 'US (us-east-1)',
  safeguards: 'SOC 2, ISO 27001, FedRAMP Moderate, HIPAA-eligible'
}, {
  vendor: 'Upstash, Inc.',
  function: 'Rate limiting (Redis)',
  data: 'Hashed request identifiers (user ID or IP) and request counts. No content.',
  region: 'US',
  safeguards: 'SOC 2 Type II, GDPR'
}, {
  vendor: 'Anthropic, PBC',
  function: 'Primary LLM inference (Claude family) for the Nisa coaching agent, Coaching Casts, and Video Coaching analysis.',
  data: 'Coach-provided notes, lesson content, and coaching log excerpts used to generate audio coaching content; transcripts of classroom recordings (name-redacted).',
  region: 'US',
  safeguards: 'SOC 2 Type II, GDPR, no training on API data. Agreement to exclude data from training in place.'
}, {
  vendor: 'OpenAI, L.L.C.',
  function: 'LLM inference (GPT family) as a configured fallback for the coaching agent and for selected tools (embeddings, supporting tasks).',
  data: 'Chat messages, coach notes, lesson content, and other text inputs sent to the model; tool call inputs/outputs.',
  region: 'US',
  safeguards: 'SOC 2 Type II, GDPR, no training on API data, zero data retention available on request. Agreement to exclude data from training in place.'
}, {
  vendor: 'Google LLC (Gemini API / Vertex AI)',
  function: 'Supplemental LLM inference, including optional analysis of short flagged video clips in Video Coaching.',
  data: 'Same text categories as above; short video clip excerpts when the flagged-clip analysis is enabled.',
  region: 'US',
  safeguards: 'SOC 2, ISO 27001, GDPR; Agreement to exclude data from training in place.'
}, {
  vendor: 'Deepgram, Inc.',
  function: 'Speech-to-text transcription of classroom recordings for the Video Coaching feature (Nova-3 model, speaker diarization). Personal names are redacted by Deepgram before the transcript is returned to Nisa.',
  data: "Audio extracted from teacher-uploaded classroom recordings; resulting transcripts. May incidentally include students' voices. No video is sent.",
  region: 'US',
  safeguards: 'SOC 2 Type II, HIPAA-eligible, GDPR; no training on API data.'
}, {
  vendor: 'Langfuse GmbH',
  function: 'LLM observability and tracing (us.cloud.langfuse.com)',
  data: 'Agent traces: prompts, completions, tool calls, latency, user ID, thread ID. May contain coach-entered text.',
  region: 'US (us.cloud.langfuse.com)',
  safeguards: 'SOC 2 Type II in progress, GDPR, encryption at rest and in transit'
}, {
  vendor: 'PostHog, Inc.',
  function: 'Product analytics, session metadata, feature flags',
  data: 'Pseudonymous app usage events, user IDs, page views, feature interactions, error events. No chat content.',
  region: 'US (us.i.posthog.com)',
  safeguards: 'SOC 2 Type II, GDPR, HIPAA BAA available'
}, {
  vendor: 'Twilio, Inc. (SendGrid)',
  function: 'Transactional email (invitations, onboarding, password resets, support notifications)',
  data: 'Recipient names and email addresses; email subject and body; delivery metadata. Limited marketing list IDs for product news.',
  region: 'US',
  safeguards: 'SOC 2 Type II, ISO 27001, GDPR, HIPAA BAA available'
}, {
  vendor: 'Twilio, Inc. (Programmable Messaging + Verify)',
  function: 'SMS messaging (chat-by-SMS) and Verify (2FA / one-time codes)',
  data: 'Phone numbers, SMS message content, verification codes, delivery metadata.',
  region: 'US',
  safeguards: 'SOC 2 Type II, ISO 27001, GDPR, HIPAA BAA available'
}, {
  vendor: 'Google LLC (Workspace OAuth, Drive, Docs, Sheets)',
  function: 'Sign-in via Google OAuth; optional read access to coaching log documents the coach explicitly links',
  data: 'Google account email and profile; document content of coach-linked files (read-only via Drive API).',
  region: 'US (global infrastructure)',
  safeguards: 'SOC 2, ISO 27001, GDPR, FedRAMP'
}];
export const SubProcessors = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-845" data-mp="214fmd554pux0">
      <main className="py-section-mobile md:py-section-desktop relative flex-grow overflow-hidden" data-id="element-846" data-mp="1w6490kfml2a1">
        {/* Background pattern */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-847" data-mp="1r947mmtq0np9" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/15 via-primary-300/10 to-cyan-200/15 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-848" data-mp="2oujm31f75aiq" />
        {/* Floating gradient blobs */}
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-cyan-400/10 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-849" data-mp="29yarwea5xnd6" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/10 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-850" data-mp="13flzb0kec2nn" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/10 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-851" data-mp="3qpecbh1hdltg" />
        <div className="absolute bottom-0 left-1/4 w-[700px] h-[700px] bg-gradient-to-r from-emerald-400/10 via-green-400/10 to-cyan-400/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '3s'
      }} data-id="element-852" data-mp="3hrkj4ez0j8ai" />
        {/* Content container */}
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-853" data-mp="2u1zvvjvttovf">
          <h1 className="text-4xl md:text-5xl font-serif font-normal text-cyan-900 mb-6 text-center" data-id="element-854" data-mp="2z01hockn02al">
            Nisa Sub-processors
          </h1>

          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-855" data-mp="2p12eh9in4yuz">
            <p className="text-gray-500 mb-8" data-id="element-856" data-mp="25f0kq1v6ucbz">Last Updated: September 2026</p>

            <p className="mb-6 text-gray-700 leading-relaxed" data-id="element-857" data-mp="25h3kveq21luf">
              Nisa engages and uses third party sub-processors
              ("Sub-processors") to help us provide the Services.
            </p>
            <p className="mb-6 text-gray-700 leading-relaxed" data-id="element-858" data-mp="2aed60i6evbcg">
              Sub-processors provide infrastructure, data storage, system
              logging services, and other tools that facilitate the delivery of
              the Services including customer support and email communications.
              These Sub-processors may be provided access to Customer Content
              and Mentions that may contain information about individuals,
              however they are only permitted to use this information to support
              the Services.
            </p>
            <p className="mb-8 text-gray-700 leading-relaxed" data-id="element-859" data-mp="382dmbls6qe3o">
              As part of Nisa's commitment to keep your data secure, we evaluate
              our Sub-processors' privacy and security practices prior to
              engaging them. We also require our Sub-processors to enter into
              data processing agreements that maintain the confidentiality of
              your data and incorporate data protection obligations consistent
              with applicable privacy laws.
            </p>

            <h2 className="text-2xl font-serif font-normal text-gray-600 mb-4" data-id="element-860" data-mp="22lmo6fgbnntp">
              Sub-processors
            </h2>

            {/* Table (scrolls horizontally on small screens) */}
            <div className="overflow-x-auto -mx-2 sm:mx-0" data-id="element-861" data-mp="19x7bw0okrjm2">
              <table className="w-full min-w-[720px] border-collapse text-sm" data-id="element-862" data-mp="1exd3jguuh645">
                <thead data-id="element-863" data-mp="1jpd0d0fmbiwi">
                  <tr className="text-left text-gray-800 border-b border-gray-200" data-id="element-864" data-mp="1jpwioi96k9b2">
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-865" data-mp="m8o2fhtsh0se">
                      Vendor
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-866" data-mp="r6zbvrg699a3">
                      Function
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-867" data-mp="30hi7j4xbdsac">
                      Data processed
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-868" data-mp="2vhm0sxx8fmr3">
                      Region
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-869" data-mp="2qisrlhozahwq">
                      Safeguards / certifications
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-870" data-mp="2gry2m5kcl47l">
                  {subProcessors.map(sp => <tr key={sp.vendor} className="border-b border-gray-100 align-top text-gray-700" data-id="element-871" data-mp="2crnv2ogwq5qm">
                      <td className="py-4 px-3 font-medium text-gray-800 whitespace-normal" data-id="element-872" data-mp="27t2s4ha9t7yh">
                        {sp.vendor}
                      </td>
                      <td className="py-4 px-3 leading-relaxed" data-id="element-873" data-mp="22sybmr9d4d89">
                        {sp.function}
                      </td>
                      <td className="py-4 px-3 leading-relaxed" data-id="element-874" data-mp="2l0po7qf2ghhd">{sp.data}</td>
                      <td className="py-4 px-3 whitespace-nowrap" data-id="element-875" data-mp="2kyl90cbpvw1s">
                        {sp.region}
                      </td>
                      <td className="py-4 px-3 leading-relaxed" data-id="element-876" data-mp="2tsrlxgxr3jny">
                        {sp.safeguards}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <h2 className="text-2xl font-serif font-normal text-gray-600 mt-10 mb-4" data-id="element-877" data-mp="22120rax32hgf">
              Updates
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-878" data-mp="1x4bkamhd9juh">
              In the event Nisa adds or removes Sub-processors, Nisa will post
              such updates on this page.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-879" data-mp="265ruou86llyp" />
    </div>;
};